"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandValueAtIndex = exports.setValueAtIndex = exports.getValueAtIndex = exports.findMaskFieldBoundariesAtPosition = void 0;
var defaultConfig = {
    maskChar: '_',
    allowedChars: /^[\d]$/,
};
/**
 * Find boundaries of mask field in specified cursor position.
 *
 * Returns array with start and end index of a field.
 * End index points next character after field (useful for `String.substring`).
 * If values are the same most probably passed cursor position is not a correct value (eg. separator).
 *
 * @param mask
 * @param cursorPosition
 * @param config
 * @return [number, number]
 */
var findMaskFieldBoundariesAtPosition = function (mask, cursorPosition, config) {
    if (cursorPosition === void 0) { cursorPosition = 0; }
    if (config === void 0) { config = {}; }
    var conf = Object.assign(defaultConfig, config);
    var isAllowedChar = function (char) {
        return conf.allowedChars.test(char) || char === conf.maskChar;
    };
    var startIndex = cursorPosition;
    var endIndex = cursorPosition;
    if (isAllowedChar(mask[cursorPosition])) {
        while (mask[startIndex - 1] &&
            isAllowedChar(mask[startIndex - 1]) &&
            startIndex - 1 >= 0) {
            startIndex--;
        }
        while (mask[endIndex + 1] &&
            isAllowedChar(mask[endIndex + 1]) &&
            endIndex + 1 < mask.length) {
            endIndex++;
        }
    }
    else {
        return [cursorPosition, cursorPosition];
    }
    return [startIndex, endIndex + 1];
};
exports.findMaskFieldBoundariesAtPosition = findMaskFieldBoundariesAtPosition;
var getValueAtIndex = function (mask, index, config) {
    if (config === void 0) { config = {}; }
    var _a = exports.findMaskFieldBoundariesAtPosition(mask, index, config), startIndex = _a[0], endIndex = _a[1];
    if (startIndex === endIndex) {
        return null;
    }
    return mask
        .substring(startIndex, endIndex)
        .split('')
        .filter(function (c) { return c !== '_'; })
        .join('');
};
exports.getValueAtIndex = getValueAtIndex;
function setValueAtIndex(mask, index, value, config) {
    if (config === void 0) { config = {}; }
    var conf = Object.assign(defaultConfig, config);
    var _a = exports.findMaskFieldBoundariesAtPosition(mask, index, config), start = _a[0], end = _a[1];
    if (start === end) {
        return mask;
    }
    var valueToSet = value === '' ? conf.maskChar.repeat(end - start) : value;
    var valueWithZeros = String(valueToSet).padStart(end - start, '0');
    return mask.substring(0, start) + valueWithZeros + mask.substring(end);
}
exports.setValueAtIndex = setValueAtIndex;
function expandValueAtIndex(mask, index, config) {
    if (config === void 0) { config = {}; }
    return setValueAtIndex(mask, index, exports.getValueAtIndex(mask, index, config), config);
}
exports.expandValueAtIndex = expandValueAtIndex;
//# sourceMappingURL=maskUtils.js.map